export { InvestmentsServicesMarketsPage as default } from "@nvb/ui";
